import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import Layout from '../components/layout';
import Tabs from '../components/Tabs';
import TabContent from '../components/TabContent';
import Iframe from '../components/Iframe';
import CodeBlock from '../components/CodeBlock';
import '../styles/main.scss'; /* global __PATH_PREFIX__*/
var pathPrefix = __PATH_PREFIX__;
var ExamplePage = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ExamplePage, _React$Component);
  function ExamplePage() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = ExamplePage.prototype;
  _proto.render = function render() {
    var _this$props$location = this.props.location,
      pathname = _this$props$location.pathname,
      hash = _this$props$location.hash;
    var _this$props$data = this.props.data,
      examplePageJson = _this$props$data.examplePageJson,
      file = _this$props$data.file;
    var title = examplePageJson.title,
      codeJs = examplePageJson.codeJs,
      codeHtml = examplePageJson.codeHtml;
    var selectedNavItemId = "" + pathname.split('/').pop() + hash;
    return /*#__PURE__*/React.createElement(Layout, {
      tabIndex: 1,
      selectedNavItemId: selectedNavItemId
    }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", {
      className: "title"
    }, title)), /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(TabContent, {
      name: "Result",
      hasIframe: true
    }, /*#__PURE__*/React.createElement(Iframe, {
      src: pathPrefix + "/" + file.relativePath
    })), codeJs ? /*#__PURE__*/React.createElement(TabContent, {
      name: "JavaScript"
    }, /*#__PURE__*/React.createElement(CodeBlock, {
      code: codeJs
    })) : null, codeHtml ? /*#__PURE__*/React.createElement(TabContent, {
      name: "HTML"
    }, /*#__PURE__*/React.createElement(CodeBlock, {
      code: codeHtml
    })) : null)));
  };
  return ExamplePage;
}(React.Component);
export default ExamplePage;
var query = "3909464219";